export const APP_URL = process.env.APP_URL!;
export const ANALYTICS_URL = 'https://avto.pro/api/v1/analytics/push';
export const GTM_ID = process.env.APP_GTM_ID!;
export const COOKIE_LIFETIME = 10 * (180 * 24 * 3600);
export const IS_AI_OVERVIEW_AVAILABLE = true;
export const IS_PROD_MODE = process.env.NODE_ENV === 'production'
export enum consentState {
	ACCEPTED = 'granted',
	REJECTED = 'denied',
}
export const FETCH_CACHE = IS_PROD_MODE ? false : 0
export const PART_INFO_REVALIDATE = 60 * 60 * 24
export const EMAIL_REGEX = /^(?!.*[\s\p{sc=Cyrillic}])[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/u;
export const BOT_TOKEN = process.env.BOT_TOKEN!;
export enum chatData {
	CHAT_ID = '-1001843221847',
	THREAD_ID = '54633'
}
export const SPAIN_PHONE_CODE ='+34'